import React from "react";
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  dimmedContentStyle,
  panelStyle,
  progressStyle,
  rootStyle,
  subtitleStyle,
  titleStyle,
} from "./styles";

interface AssessmentEvaluatingOverlayProps {
  active: boolean;
  children: React.ReactNode;
  evaluateMultiple?: boolean;
}

export const AssessmentEvaluatingOverlay: React.FC<
  AssessmentEvaluatingOverlayProps
> = ({ active, children, evaluateMultiple = false }) => {
  const theme = useTheme();
  const isCompactLayout = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={rootStyle}>
      <Box sx={active ? dimmedContentStyle : undefined}>{children}</Box>
      {active ? (
        <Box sx={panelStyle(theme, isCompactLayout)}>
          <CircularProgress size={36} sx={progressStyle} />
          <Typography variant="body2" sx={titleStyle(theme)}>
            {evaluateMultiple
              ? "Evaluating your answers..."
              : "Evaluating your answer..."}
          </Typography>
          <Typography variant="body2" sx={subtitleStyle(theme)}>
            This may take a few seconds
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};
